// AdminRoute.js
import React from 'react';
import { Navigate } from 'react-router-dom';
import useAuth from '../hooks/useAuth';

/**
 * Admin Route Component
 * Redirects to login if user is not authenticated
 * Redirects to home/unauthorized if user is not an admin
 */
const AdminRoute = ({ children }) => {
  const { user, userData, loading, isAdmin } = useAuth();

  // Show loading state while checking authentication
  if (loading) {
    return (
      <div style={{ 
        display: 'flex', 
        justifyContent: 'center', 
        alignItems: 'center', 
        height: '100vh' 
      }}>
        <p>Loading...</p>
      </div>
    );
  }

  // Redirect to login if not authenticated
  if (!user) {
    return <Navigate to="/login" replace />;
  }

  // Redirect to profile if authenticated but not an admin
  if (!isAdmin) {
    return <Navigate to="/profile" replace />;
  }

  // Render children if authenticated and is admin
  return children;
};

export default AdminRoute;
